module.exports = __webpack_public_path__ + "static/media/myAdvisor-01.c346d74b.svg";